<template>
  <div>
    <el-dialog title="Create Branch Offices" :visible.sync="dialogFormVisible">
      <el-form ref="subCompanyForm" :model="branchForm">
        <el-form-item label="Branch Code" :label-width="formLabelWidth">
          <el-input v-model="branchForm.Code" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Branch Name" :label-width="formLabelWidth">
          <el-input v-model="branchForm.Name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="onSubmit">{{ btnSummit }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogNewBranchOffices",
  props: ["companyId"],
  data() {
    return {
      btnSummit: "Save",
      appendToBoddy: true,
      loading: false,
      isEdit: false,
      dialogFormVisible: false,
      companyData: [],
      branchForm: {},
      formLabelWidth: "120px"
    };
  },
  methods: {
    showModal(data) {
      this.branchForm = {};
      if (data != null) {
        this.branchForm = data;
        this.isEdit = true;
        this.btnSummit = "Edit";
      } else {
        this.isEdit = false;
        this.btnSummit = "Save";
      }

      this.dialogFormVisible = true;
    },
    onSubmit() {
      this.$refs.subCompanyForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          if (!this.isEdit) {
            this.addNewSubCompany();
          } else {
            this.$http
              .put(
                `/api/companies/${this.branchForm.Id}/updateGroup`,
                this.branchForm
              )
              .then(() => {
                this.$refs.subCompanyForm.resetFields();
                this.dialogFormVisible = false;
                this.branchForm = {};
                this.$message.success("Sub Company Updated Sucessfully.");
              })
              .catch(() => {
                this.$message.error("Error Trying Update Sub Company.");
              })
              .finally(() => {
                this.loading = false;
              });
          }
        } else {
          return false;
        }
      });
    },
    addNewSubCompany() {
      this.$refs.subCompanyForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          this.$http
            .post(`/api/companies/${this.companyId}/AddGrupo`, this.branchForm)
            .then(() => {
              this.$refs.subCompanyForm.resetFields();
              this.dialogFormVisible = false;
              this.branchForm = {};
              this.$message.success("Sub Company Created Sucessfully.");
            })
            .catch(() => {
              this.$message.error("Error Trying Create Sub Company.");
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style></style>
